import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/index";
import vbclass from "vue-body-class";
import { FETCH_CURRENT_PAGE, FETCH_SETTING} from "./store/actions.names";
import axios from "axios";

//add custom js
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "animate.css";
import "./vee-validate";
import VueScrollmagic from 'vue-scrollmagic';
import * as VueGoogleMaps from "vue2-google-maps";
import VueNumber from "vue-number-animation";
import AOS from "aos";
import "aos/dist/aos.css";
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import { PreviewParams } from './types';
import { API_URL } from './global';
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);


 Vue.use(VueNumber);
Vue.use(require("vue-moment"));
Vue.use(VueAwesomeSwiper);
Vue.use(vbclass, router);
Vue.use(VueScrollmagic, {
  vertical: false
});

Vue.config.productionTip = false;
//store.dispatch(FETCH_SETTING_DATA);
store.dispatch(FETCH_SETTING).then(() => {
  // console.log("maploaded");
  Vue.use(VueGoogleMaps, {
    load: {
      key: store.getters.mapAPIKey
    },
    installComponents: true
  });
});
const isProd =
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_DEVENV === "production";
router.beforeEach((to: any, from: any, next: any) => {
  let params: string | PreviewParams;

  if (to.query.token) {
    params = to.query
  } else {
    params = to.path
  }
  store.dispatch(FETCH_CURRENT_PAGE, params).then(() => {
    next();
  }).catch(() => {
    axios.get(`${API_URL}/redirects/?path=${to.path}`).then(({ data }) => {
      if (data.type == "internal") {
        next(data.link)
      } else {
        window.location.href = data.link
      }
    }).catch(() => {
      next('/404');
    })
  })
});
Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init({
      disable: "phone",
      once: true
  });

  },
  router,
  store,
  render: h => h(App)
}).$mount("#app");
